import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';
import { get, sortBy } from 'lodash';

// components
import { Dropdown } from '@tcc/crate';

const baseString = 'vra-product-type';

const SubstanceType = ({
  disabled,
  onSelectSubstanceType,
  substanceTypes,
  selected
}) => {
  const substanceTypesByName = get(substanceTypes, 'byName', {});

  const classString = classNames({
    [`${baseString}`]: true
  });

  const selectClassString = classNames({
    [`${baseString}__select`]: true
  });

  let optionsBySubstanceTypeUuid = {};
  const options = sortBy(Object.keys(substanceTypesByName).map((name) => {
    const id = name;
    optionsBySubstanceTypeUuid[substanceTypesByName[name]] = getMessage(`fertilizer-substance-type-${name}`);
    return { id, value: getMessage(`fertilizer-substance-type-${name}`) };
  }), 'value');

  return (
    <section className={classString}>
      <Dropdown
        className={selectClassString}
        disabled={disabled}
        label={getMessage('title-text__product-type')}
        options={options}
        placeholder={getMessage('placeholder-text__select-fertilizer-type')}
        setValue={(substanceTypeName) => {
          const substanceTypeUuid = Object.keys(optionsBySubstanceTypeUuid)
          .find(key => optionsBySubstanceTypeUuid[key] === substanceTypeName);
          onSelectSubstanceType(substanceTypeUuid);
        }}
        value={optionsBySubstanceTypeUuid[selected]}
      />
    </section>
  );
};

SubstanceType.propTypes ={
  disabled: propTypes.bool,
  onSelectSubstanceType: propTypes.func.isRequired,
  selected: propTypes.string,
  substanceTypes: propTypes.object.isRequired
};
export default SubstanceType;
